import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ClubCampaignBanner = ({ team, lang, href }) => {
  const copy = lang === 'fr' ? team.fr : team.en;
  const prefix = href ? 'home-st-leonard' : 'team-hero';
  const Heading = href ? 'h2' : 'h1';
  const Frame = href ? Link : 'div';
  const cta = lang === 'fr' ? 'Découvrir la collection 2027' : 'Explore the 2027 collection';
  const alt = lang === 'fr'
    ? "Les joueurs de l'AS St-Léonard en tenue de match marine et ciel sous les projecteurs."
    : 'AS St-Léonard players in navy and sky match kits under the stadium lights.';

  return (
    <section
      className={`relative bg-[#0D0D0D] border-b border-white/15 ${href ? '' : 'pt-24'}`}
      data-testid={href ? 'home-st-leonard-feature' : 'team-hero'}
      aria-label={`${team.name} — ${copy.collectionTitle}`}
    >
      <Frame
        {...(href ? { to: href, 'aria-label': `${team.name} — ${cta}` } : {})}
        className="group relative block w-full aspect-[4/5] sm:aspect-[16/9] lg:aspect-[12/5] max-h-[660px] overflow-hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-white"
        data-testid={`${prefix}-${href ? 'link' : 'frame'}`}
      >
        <img
          src={team.banner}
          alt={alt}
          width="2000"
          height="1125"
          loading={href ? 'lazy' : 'eager'}
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover object-top"
          data-testid={`${prefix}-image`}
        />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/90 via-black/35 to-transparent" aria-hidden="true" />
        <div className="absolute inset-x-0 bottom-0 px-6 md:px-10 lg:px-14 pb-6 md:pb-9">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-3">
              <img src={team.logo} alt="" width="40" height="40" className="w-10 h-10 shrink-0 object-contain" data-testid={href ? 'home-st-leonard-crest' : 'team-crest'} />
              <p className="font-dm text-[11px] font-semibold text-[#A9E1FC]" data-testid={`${prefix}-season`}>
                {copy.collectionTitle}{!href && team.founded ? ` · ${lang === 'fr' ? 'FONDÉ EN' : 'EST.'} ${team.founded}` : ''}
              </p>
            </div>
            <Heading className="font-bebas text-4xl sm:text-5xl lg:text-6xl leading-none text-white" data-testid={href ? 'home-st-leonard-title' : 'team-collection-title'}>
              {team.name}
            </Heading>
            {href ? (
              <span className="inline-flex max-w-full items-center gap-3 mt-5 px-5 py-3 bg-white text-[#0D0D0D] font-dm text-xs font-semibold group-hover:bg-[#CE2B37] group-hover:text-white transition-colors duration-200" data-testid="home-st-leonard-cta">
                {cta}<ArrowRight size={17} className="shrink-0 group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" />
              </span>
            ) : (
              <p className="mt-3 font-dm text-[11px] text-white/85" data-testid="team-hero-categories">
                {copy.categories}<span className="hidden sm:inline"> · {copy.suppliedBy}</span>
              </p>
            )}
          </div>
        </div>
      </Frame>
    </section>
  );
};